
export const customModalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        whiteSpace: 'pre-wrap',
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
        width: '60%',
        height: 'auto'
    }
}

let selectInFocusWithin = false
export const customCreatableSelectStyles = {
    control: (base, state) => {
        selectInFocusWithin = state.isFocused
        return {
        ...base,
        flex: "4",
        fontSize: "12px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        color: "#000",
        backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
        borderColor: "#d9d9d9 #ccc #b3b3b3",
        borderRadius: "2px",
        border: "1px solid #d9d9d9",
        minHeight: "25px",
        maxHeight: "auto",
        //height: state.isFocused ? "auto" : "25px",
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
        borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        "&:focus": {
        borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        padding: 0,
        margin: 0,
        overflow: state.isFocused ? null : "hidden"
    }},
    menu: base => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word"
    }),
    menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline"
    }),
    singleValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        color: "black",
    }),
    multiValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        maxHeight: "18px",
        border: "0.5px solid #388957",
        background: '#46b270',
        color: "black",
        div: {
            color: "black",
            fontSize: '1.2em',
            lineHeight: '0.8em'
        }
    }),
    /* noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        height: "20px",
        lineHeight: "16px"
    }), */
    option: (base, state) => ({
        ...base,
        padding: 0,
        fontSize: '1em',
        maxHeight: "25px"
    }),
    valueContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        top: 0
    }),
    multiValueRemove: (base, state) => ({
        ...base,
        display: state.isDisabled ? "none" : null,
        padding: 0
    }),
    clearIndicator: (base, state) => ({
        ...base,
        padding: 0
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        marginTop: 0,
        padding: 0
    }),
    indicatorsContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "23px",
        top: 0
    }),
    indicatorSeparator: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0
    }),
    group: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
    }),
    groupHeading: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
    }),
    input: (base, state) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '1.2em',
        lineHeight: '0.8em',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        }
    }),
    noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '1em'
    }),
    placeholder: (base, state) => ({
        ...base,
        fontSize: '1.1em',
        lineHeight: '1.1em'
    })
}


// WEBPACK FOOTER //
// ./components/ClaimsWizard/shared/customStyles.js